import { render, staticRenderFns } from "./OrgManage.vue?vue&type=template&id=4e6abc0c&scoped=true&"
import script from "./OrgManage.vue?vue&type=script&lang=js&"
export * from "./OrgManage.vue?vue&type=script&lang=js&"
import style0 from "./OrgManage.vue?vue&type=style&index=0&id=4e6abc0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6abc0c",
  null
  
)

component.options.__file = "OrgManage.vue"
export default component.exports